<template>
<div class="viplist">

<div  class="record_vip" style="animation-delay: 0s;">
    <img  src="https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJsMsezQmCSNnebSkb4lB1rB2gJlicI8E1y5ZnVO4SCic6fH6kbbblOnOEqLnsu3Qw8Yia1ib99ToT1oA/132" class="avatar">
    <span >刚刚加入了会员</span>
</div>

<div  class="record_vip" style="animation-delay: 1.5s;">
    <img  src="https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ7yldlgFjCYic2VickcNxowAA4KwRLeCykgbGuD7R8iaYUzGA2UAbWa9lLgZMWwlA0WykevfLpic2cnQ/132" class="avatar">
    <span >刚刚加入了会员</span>
</div>

<div  class="record_vip" style="animation-delay: 3s;">
    <img  src="https://thirdwx.qlogo.cn/mmopen/vi_32/POYn4YEjQVbTiaDWNAZMPk4Q7NjFoC49Cg527B65w2COEkWGt7cIwaKxLMsIpcDeBC6eHs1iaARWaW7TGZ4Vib9MA/132" class="avatar">
    <span>3分钟前加入加入了会员</span>
</div>

<div  class="record_vip" style="animation-delay: 4.5s;">
    <img  src="https://thirdwx.qlogo.cn/mmopen/vi_32/tx8CtJ3W5ibymjAmK1UMC8akfiaRwD16B1xOjBM48l0BWyMhicRV2AvFJMyLWSrW26BsQu8FvAaqSeysMQ2wOFkUw/132" class="avatar">
    <span >5分钟前加入加入了会员</span>
</div>



</div>
</template>


<style lang="less" scoped>

.viplist .record_vip{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 10px;
    bottom:100px;
    background-color: rgba(34, 34, 34, 0.6);
    border-radius: 10px;
    color: #ffffff;
    font-size: 0.15rem;
    -webkit-animation: jiaru 6s linear infinite;
    animation: jiaru 6s linear infinite;
    opacity: 0;z-index: 100;padding:0px 10px ;
    transform: translateY(3rem);
}


.viplist .record_vip .avatar{
    position: relative;
    width: 10px;
    height: 10px;
    margin-right:10px;
    border-radius: 50%;
    background-color: black;
}





@keyframes jiaru {

0% {
opacity: 0;
transform: translateY(1rem);
}
25% {
opacity: 1;
transform: translateY(0.5rem);
}
50% {
opacity: 1;
transform: translateY(0rem);
}
75% {
opacity: 1;
transform: translateY(-0.5rem);
}
100% {
opacity: 0;
transform: translateY(-1rem);
}


}








</style>

<script>
  export default {
    name: 'qipao',
    data() {
      return {
        backStatu:false,
        user:null
      }
    },
    created(){

    },methods:{


}

}

</script>

